import Vue from 'vue'
import Router from 'vue-router'
import { getLocalStorage, getToken, removeToken, clearLocalStorage, saveLocalStorage } from '@/utils/auth'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
// import zsmLayout from '@/zsm-layout'
// import zsmLayout from '@/zsm-layout-new'

/* Router Modules */
/* 讲师路由信息*/
import statisticsRouter from './modules/statistics' // 统计
import accountRouter from './modules/account' // 统计
import shopRouter from './modules/shop' // 门店
import courseRouter from './modules/course' // 内容管理
import materialRouter from './modules/material' // 素材库
import tiktokRouter from './modules/tiktok' // 抖音
import fundRouter from './modules/fund' // 资金
import userIndex from './modules/user' // 用户首页
import tutorialRouter from './modules/tutorial.js' // 教程
import serveRouter from './modules/serve.js' // 服务
import marketRouter from './modules/market.js' // 套餐
import examRouter from './modules/exam.js' // 考试
import merchandiseRouter from './modules/merchandise.js' // 商品服务/应用
import postsRouter from './modules/posts.js' // 社区
import moreRouter from './modules/more.js' // 更多
import douyinRouter from './modules/douyin.js' // 抖音
import weixinRouter from './modules/weixin.js' // 社区
import distributionRouter from './modules/distribution.js' //达人关联
import overviewRouter from './modules/overview.js' //数据管理
import smsRouter from './modules/sms.js' //短信充值
import complaintsRouter from './modules/complaints.js' //客诉
import certificationRouter from './modules/certification.js' //资质
import interactionRouter from './modules/interaction' //私域管理
import payRouter from './modules/pay' //付费管理
import xiaohongshuRouter from "./modules/xiaohongshu.js" //小红书
// import mountscopeRouter from './modules/mountscope.js' //达人绑定



import homeRouter from './modules/index'  //抖音
// import courseCRouter from './modules/course-c.js' // C端用户查看课程

/* 代理商路由信息*/

import agentUserRouter from './agent-modules/user' // 代理商首页
import agentLecturerRouter from './agent-modules/lecturer' // 代理商讲师列表
import agentSalesmanRouter from './agent-modules/team' // 代理商讲师列表
import agentStatisticsRouter from './agent-modules/statistics' // 代理商讲师列表
import agentIncomeRouter from './agent-modules/income' // 代理商讲师列表
import agentSettingRouter from './agent-modules/account' // 代理商讲师列表

export const constantRoutes = [

  {
    path: '/login',
    hidden: true,
    component: () => import('@/view/login/index')
  },
  // {
  //   path: '/dyVideoUpload',
  //   hidden: true,
  //   component: () => import('@/view/demo/dyVideoUpload')
  // },
  {
    path: '/agent',
    hidden: true,
    component: () => import('@/view/agent/login')
  },
  {
    hidden: true,
    path: '/agreement',
    component: () => import('@/view/login/agreement')
  },
  {
    redirect: '/user',
    path: '/',
    hidden: true,
    component: () => import('@/view/user/index') // 用户中心页
  },

  agentSettingRouter,
  agentUserRouter,
  agentLecturerRouter,
  agentSalesmanRouter,
  agentStatisticsRouter,
  agentIncomeRouter,
  statisticsRouter,
  payRouter,
  // mountscopeRouter,
  userIndex,
  fundRouter,
  shopRouter,
  courseRouter,
  serveRouter,
  materialRouter,
  tiktokRouter,
  tutorialRouter,
  accountRouter,
  marketRouter,
  examRouter,
  merchandiseRouter,
  postsRouter,
  moreRouter,
  douyinRouter,
  weixinRouter,
  distributionRouter,
  overviewRouter,
  smsRouter,
  complaintsRouter,
  certificationRouter,
  interactionRouter,
  xiaohongshuRouter
  /* {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
*/
  /* {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  }*/
  /* {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: 'Dashboard', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/documentation',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/documentation/index'),
        name: 'Documentation',
        meta: { title: 'Documentation', icon: 'documentation', affix: true }
      }
    ]
  },
  {
    path: '/guide',
    component: Layout,
    redirect: '/guide/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/guide/index'),
        name: 'Guide',
        meta: { title: 'Guide', icon: 'guide', noCache: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  }
]

/!**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 *!/
export const asyncRoutes = [
  {
    path: '/permission',
    component: Layout,
    redirect: '/permission/page',
    alwaysShow: true, // will always show the root menu
    name: 'Permission',
    meta: {
      title: 'Permission',
      icon: 'lock',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [
      {
        path: 'page',
        component: () => import('@/views/permission/page'),
        name: 'PagePermission',
        meta: {
          title: 'Page Permission',
          roles: ['admin'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'directive',
        component: () => import('@/views/permission/directive'),
        name: 'DirectivePermission',
        meta: {
          title: 'Directive Permission'
          // if do not set roles, means: this page does not require permission
        }
      },
      {
        path: 'role',
        component: () => import('@/views/permission/role'),
        name: 'RolePermission',
        meta: {
          title: 'Role Permission',
          roles: ['admin']
        }
      }
    ]
  },

  {
    path: '/icon',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/icons/index'),
        name: 'Icons',
        meta: { title: 'Icons', icon: 'icon', noCache: true }
      }
    ]
  },

  /!** when your routing map is too long, you can split it into small modules **!/
  componentsRouter,
  chartsRouter,
  nestedRouter,
  tableRouter,

  {
    path: '/example',
    component: Layout,
    redirect: '/example/list',
    name: 'Example',
    meta: {
      title: 'Example',
      icon: 'el-icon-s-help'
    },
    children: [
      {
        path: 'create',
        component: () => import('@/views/example/create'),
        name: 'CreateArticle',
        meta: { title: 'Create Article', icon: 'edit' }
      },
      {
        path: 'edit/:id(\\d+)',
        component: () => import('@/views/example/edit'),
        name: 'EditArticle',
        meta: { title: 'Edit Article', noCache: true, activeMenu: '/example/list' },
        hidden: true
      },
      {
        path: 'list',
        component: () => import('@/views/example/list'),
        name: 'ArticleList',
        meta: { title: 'Article List', icon: 'list' }
      }
    ]
  },

  {
    path: '/tab',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/tab/index'),
        name: 'Tab',
        meta: { title: 'Tab', icon: 'tab' }
      }
    ]
  },

  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'Error Pages',
      icon: '404'
    },
    children: [
      {
        path: '401',
        component: () => import('@/views/error-page/401'),
        name: 'Page401',
        meta: { title: '401', noCache: true }
      },
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: { title: '404', noCache: true }
      }
    ]
  },

  {
    path: '/error-log',
    component: Layout,
    children: [
      {
        path: 'log',
        component: () => import('@/views/error-log/index'),
        name: 'ErrorLog',
        meta: { title: 'Error Log', icon: 'bug' }
      }
    ]
  },

  {
    path: '/excel',
    component: Layout,
    redirect: '/excel/export-excel',
    name: 'Excel',
    meta: {
      title: 'Excel',
      icon: 'excel'
    },
    children: [
      {
        path: 'export-excel',
        component: () => import('@/views/excel/export-excel'),
        name: 'ExportExcel',
        meta: { title: 'Export Excel' }
      },
      {
        path: 'export-selected-excel',
        component: () => import('@/views/excel/select-excel'),
        name: 'SelectExcel',
        meta: { title: 'Export Selected' }
      },
      {
        path: 'export-merge-header',
        component: () => import('@/views/excel/merge-header'),
        name: 'MergeHeader',
        meta: { title: 'Merge Header' }
      },
      {
        path: 'upload-excel',
        component: () => import('@/views/excel/upload-excel'),
        name: 'UploadExcel',
        meta: { title: 'Upload Excel' }
      }
    ]
  },

  {
    path: '/zip',
    component: Layout,
    redirect: '/zip/download',
    alwaysShow: true,
    name: 'Zip',
    meta: { title: 'Zip', icon: 'zip' },
    children: [
      {
        path: 'download',
        component: () => import('@/views/zip/index'),
        name: 'ExportZip',
        meta: { title: 'Export Zip' }
      }
    ]
  },

  {
    path: '/pdf',
    component: Layout,
    redirect: '/pdf/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/pdf/index'),
        name: 'PDF',
        meta: { title: 'PDF', icon: 'pdf' }
      }
    ]
  },
  {
    path: '/pdf/download',
    component: () => import('@/views/pdf/download'),
    hidden: true
  },

  {
    path: '/theme',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/theme/index'),
        name: 'Theme',
        meta: { title: 'Theme', icon: 'theme' }
      }
    ]
  },

  {
    path: '/clipboard',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/clipboard/index'),
        name: 'ClipboardDemo',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      }
    ]
  },

  {
    path: 'external-link',
    component: Layout,
    children: [
      {
        path: 'https://github.com/PanJiaChen/vue-element-admin',
        meta: { title: 'External Link', icon: 'link' }
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }*/
]

const createRouter = () => new Router({
  mode: 'hash', // require service support
  base: '/login/',
  // mode: 'history', // require service support
  // scrollBehavior: () => ({ y: 0, x: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.onError(function (error) {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

// 设置路由拦截
router.beforeEach(function (to, from, next) {
  // var zsmWebUserPermission = JSON.parse(getLocalStorage('zsm_web_user_permission_dict'))
  // console.log(zsmWebUserPermission)

  //  从其他地方访问是否有这个地址

  // if (to.matched.length == 0) {
  //   next('/404')
  // } else {
  if (to.path == '/tutorial/detail' || to.path == '/tutorial/index' || to.path == '/agreement' || to.path == '/login' || to.path == '/agent') {
    next()
  } else {
    if (!getLocalStorage('zsm-login') || !getLocalStorage('zsm-mobile') || !getLocalStorage('zsm-userInfo') || !getLocalStorage('zsm-versions')) {
      if (to.path !== '/login') {
        removeToken('zsm-token')
        clearLocalStorage()
        return next('/login')
      }
    }
  }
  next()
});

export default router
